import { Entries, Field } from 'src/api/contentful/utilTypes';

export enum ContentType {
  SECTION_DOCUMENT = 'section-document',
  PAGE_SIMPLE = 'page-simple',
}

export type Page = Field<{
  title: string;
  components: Entries<SectionDocument>;
}>;

// Terms, Privacy, etc. pages that need to be
// included for US initial launch
export type SectionDocument = Field<{
  name: string;
  body: string;
}>;
